// AWS configuration - These values will be populated after CDK deployment
const awsConfig = {
  aws_project_region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  aws_cognito_identity_pool_id: process.env.REACT_APP_IDENTITY_POOL_ID,
  aws_cognito_region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  aws_user_pools_id: process.env.REACT_APP_USER_POOL_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_USER_POOL_CLIENT_ID,
  oauth: {},
  aws_cognito_username_attributes: ['email'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['email'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      'requireLowercase',
      'requireUppercase',
      'requireDigits',
      'requireSymbols'
    ]
  },
  aws_cognito_verification_mechanisms: ['email'],
  
  // API Gateway configuration
  aws_cloud_logic_custom: [
    {
      name: 'ReportingAPI',
      endpoint: process.env.REACT_APP_API_URL,
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1'
    }
  ]
};

export default awsConfig;